export const IS_APP_ENV_DEV = process.env.NODE_ENV == 'development'
export const apiBaseUrl = IS_APP_ENV_DEV ? process.env.REACT_APP_API_URL : window.location.origin
export const API_URL = `${apiBaseUrl}/api-admin`;
export const AWS_S3_BUCKET_URL = process.env.REACT_APP_AWS_S3_BUCKET_URL
export const ZOHO_WIDGET_CODE = process.env.REACT_APP_ZOHO_WIDGET_CODE
export const PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY
export const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER
export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY